<template>
  <div>

    <!---->
    <div v-if="!domains.length && !isAdmin">
      <div class="form-group">
        <label for="registry" class="form-label">Matrícula</label>
        <input id="registry" type="tel" class="form-input" name="registry" value="" required autofocus v-model="registry"
          placeholder="xxxxxxxxx" />
      </div>

      <div class="form-group">
        <label for="password" class="form-label">Senha</label>
        <input id="password" type="password" class="form-input" name="password" required v-model="password"
          placeholder="******" />
      </div>

      <div class="form-group">
        <div class="block m-b-sm text-right m-r-lg">
          <span style="font-size: 14px; float: left; margin-top: -2px" class="m-l-lg">
            <input type="checkbox" /> Lembre-me
          </span>

          <a href="" data-toggle="modal" data-target="#myModal" style="font-size: 14px">Esqueci minha Senha</a>
        </div>

        <button type="submit" class="form-button" @click="domainLogin">
          <i class="fa fa-sign-in"></i> Entrar
        </button>
        <br>
        <u @click="isAdmin = true" style="cursor:pointer;color:#0000EE; margin-top:5px; display:inline-block">Acesso para
          administradores</u>
      </div>

      <div id="myModal" class="modal fade" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <h4 class="modal-title">Formulário de Recuperação de Senha</h4>
            </div>

            <div class="modal-body">
              <form action="">
                <div class="form-group">
                  <label for="">E-mail</label>
                  <input type="email" name="email" class="form-control email" v-model="forgot.email" />
                </div>
              </form>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                Cancelar
              </button>
              <button type="button" class="btn btn-primary" @click="forgotPassword">
                Solicitar Recuperação
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAdmin">
      <div class="form-group">
        <label for="adminEmail" class="form-label">Email</label>
        <input autocomplete="on" class="form-input" type="email" name="email" required placeholder="exemplo@email.com"
          autofocus v-model="adminEmail" />
      </div>

      <div class="form-group">
        <label for="password" class="form-label">Senha</label>
        <input id="password" type="password" class="form-input" name="password" required v-model="adminPassword"
          placeholder="******" />
      </div>

      <div class="form-group">
        <button type="submit" class="form-button" @click="adminLogin">
          <i class="fa fa-sign-in"></i> Entrar
        </button>
        <br>
        <u @click="isAdmin = false" style="cursor:pointer;color:#0000EE; margin-top:5px; display:inline-block">Voltar</u>
      </div>

    </div>
    <!---->
    <div v-if="domains.length && !isAdmin">
      <div>
        <div class="card">
          <div class="card-header">
            <label style="font-weight:bold; font-size:20px">Você possui cadastro nos seguintes domínios! Selecione um para ser redirecionado:</label>
          </div>
          <div class="card-body">
            <v-select
              v-model="selectedDomain"
              :options="filteredDomains"
              label="tenant"
              placeholder="Pesquisar Domínios"
              @input="handleDomainSelect"
            ></v-select>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      searchText:'',
      selectedDomain: null,
      adminEmail: '',
      adminPassword: '',
      registry: "",
      password: '',
      isAdmin: false,
      domains: [],
      forgot: {
        email: "",
      },

    };
  },
  methods: {
    mounted() {
      // Inicializa o Select2 no elemento com a classe select2
      $(".select2").select2();
    },
    handleDomainSelect() {
      if (this.selectedDomain) {
        const { tenant, hashed_token } = this.selectedDomain;
        this.redirect(tenant, hashed_token);
      }
    },
    redirect(tenant, hashed_token) {
      window.location.replace("https://" + tenant + ".innovareti.com.br/?hashed_token=" + hashed_token)
    },
    domainLogin() {
      const self = this;
      const api = this.$store.state.api + "domainLoginWeb";

      axios
        .post(api, {
          registry: self.registry,
          password: self.password
        })
        .then((response) => {
          if (response.data.length > 1) {
            self.domains = response.data;
          } else {
            self.redirect(response.data[0].tenant, response.data[0].hashed_token)
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    adminLogin() {
      const self = this;
      const api = this.$store.state.api + "adminLogin";

      axios
        .post(api, {
          email: self.adminEmail,
          password: self.adminPassword,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push({ path: "/domains" });
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    forgotPassword() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  computed: {
  filteredDomains() {
    if (this.searchText) {
      const searchTextLower = this.searchText.toLowerCase();
      return this.domains.filter((domain) =>
        domain.tenant.toLowerCase().includes(searchTextLower)
      );
    } else {
      return this.domains;
    }
  },
},

};
</script>

<style>
body {
  font-family: "Roboto", sans-serif;
}

.company-img {
  position: relative;
  z-index: 2;
  width: 14%;
  margin-left: 17px;
  margin-top: 3px
}

.company-span {
  z-index: 2;
  font-size: 200%;
  position: relative;
  top: 5px;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.round-company {
  border: solid 2px grey;
  margin-bottom: 10px;
  margin-top: 10px;
  background-color: white;
  /* -webkit-border-radius: 15%; */
  /* -moz-border-radius: 15%; */
}

.cta {
  z-index: 1;
  position: relative;
  transition: all .2s ease;
}

.cta:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background: rgba(27, 55, 111, 255);
  width: 0%;
  height: 100%;
  transition: all .3s ease;
}

.cta:hover {
  color: lightgrey
}

.cta svg {
  position: relative;
  top: 0;
  margin-left: 10px;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke: #111;
  stroke-width: 2;
  transform: translateX(-5px);
  transition: all .3s ease;
}

.cta:hover:before {
  width: 100%;
  background: rgba(27, 55, 111, 255);
}

.cta:hover svg {
  transform: translateX(0);
}

.cta:active {
  transform: scale(0.96);
}

.form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}

.form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}

.form-button {
  width: 70%;
  padding: 5px;
  font-size: 18px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}

.circle {
  background-color: #fff;
  border: 3px solid grey;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  height: 120%;
  width: 20%;
}

@media screen and (min-width: 1024px) {
  .lg {
    width: 50%;
    padding: 10px;
    border-radius: 10px;
    background-color: white !important;
  }
}

@media screen and (max-width: 1024px) {
  .lg {
    padding: 35px;
    border-radius: 10px;
    background-color: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Domains/DomainsLogin.vue